import { render, staticRenderFns } from "./RsaScalaValutazioneDoloreEditComponent.vue?vue&type=template&id=27f89d09"
import script from "./RsaScalaValutazioneDoloreEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaScalaValutazioneDoloreEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports